export { default } from "./useHideContent";
